export default __webpack_public_path__ + "static/whychooseportal-718f49c7cd37792d5407c79a627567bb.webp";